import React from 'react';
import { motion } from 'framer-motion';
import { ShoppingBag, Sparkles, Smartphone, Stethoscope, X } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export function WhyFailSection() {
  const {
    t
  } = useLanguage();
  const failures = [{
    icon: ShoppingBag,
    title: t('whyFail.f1_title'),
    description: t('whyFail.f1_desc')
  }, {
    icon: Smartphone,
    title: t('whyFail.f2_title'),
    description: t('whyFail.f2_desc')
  }, {
    icon: Sparkles,
    title: t('whyFail.f3_title'),
    description: t('whyFail.f3_desc')
  }, {
    icon: Stethoscope,
    title: t('whyFail.f4_title'),
    description: t('whyFail.f4_desc')
  }];
  return <section className="py-12 md:py-24 bg-brand-dark text-white relative" data-id="element-477" data-mp="1uf2xg4584m83">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-478" data-mp="wx2xaq5ll4ez">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10 md:mb-16 max-w-3xl mx-auto" data-id="element-479" data-mp="11x7ekieby369">
          <h2 className="text-3xl md:text-4xl font-serif text-brand-gold-light mb-4 md:mb-6" data-id="element-480" data-mp="2zquzloah9gxc">
            {t('whyFail.title')}
          </h2>
          <p className="text-lg text-gray-300" data-id="element-481" data-mp="2qsswn376oe7f">{t('whyFail.subtitle')}</p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-482" data-mp="2lsn83vw7n7tk">
          {failures.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white/5 border border-white/10 p-8 rounded-sm hover:bg-white/10 transition-colors" data-id="element-483" data-mp="2gtbrcmvug2bz" data-mpi={index}>
              <div className="flex items-start" data-id="element-484" data-mp="29cnmjqf0sxod">
                <div className="flex-shrink-0 relative" data-id="element-485" data-mp="1vjz0sh3bf04c">
                  <div className="w-12 h-12 bg-brand-gold/20 rounded-full flex items-center justify-center text-brand-gold-light" data-id="element-486" data-mp="1vhcueks5uqnp">
                    <item.icon className="w-6 h-6" data-id="element-487" data-mp="2n9u3rgk3iobh" />
                  </div>
                  <div className="absolute -bottom-1.5 -right-1.5 w-5 h-5 flex items-center justify-center" data-id="element-488" data-mp="2s9gcpdsw5ieh">
                    <svg viewBox="0 0 20 20" className="w-5 h-5" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-489" data-mp="2e9xh1kh9nzj2">
                      <circle cx="10" cy="10" r="9" stroke="rgba(183,135,98,0.5)" strokeWidth="1" fill="rgba(60,40,30,0.85)" data-id="element-490" data-mp="12u8s4nkgcqfm" />
                      <path d="M7 7l6 6M13 7l-6 6" stroke="rgba(183,135,98,0.8)" strokeWidth="1.2" strokeLinecap="round" data-id="element-491" data-mp="vbr6jizaxl6a" />
                    </svg>
                  </div>
                </div>
                <div className="ml-6" data-id="element-492" data-mp="gn4qtg5rirej">
                  <h3 className="text-xl font-serif text-white mb-3" data-id="element-493" data-mp="gk0hk4dfx5h0">
                    {item.title}
                  </h3>
                  <p className="text-gray-400 leading-relaxed" data-id="element-494" data-mp="qbmohoiqwidy">
                    {item.description}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="mt-16 text-center" data-id="element-495" data-mp="3u0gbl8361tx9">
          <p className="text-xl text-brand-gold-light font-medium mb-4" data-id="element-496" data-mp="31b7u0ntictui">
            {t('whyFail.conclusion1')}
          </p>
          <p className="text-2xl md:text-3xl font-serif" data-id="element-497" data-mp="3626b3pmblvyt">
            {t('whyFail.conclusion2')}
          </p>
        </motion.div>
      </div>
    </section>;
}